module.exports = __webpack_public_path__ + "img/assembling-machine-2.3b25d098.png";